import colorUtils from 'color';
import { omit } from 'lodash';
import theme from 'app/theme';

function lighten(color) {
  if (color === 'transparent') return color;
  return colorUtils(color)
    .lighten(0.1)
    .hex();
}

function darken(color) {
  if (color === 'transparent') return color;
  return colorUtils(color)
    .darken(0.1)
    .hex();
}

export function makeSimpleButtonStyle(config) {
  const {
    background,
    color,
    hoverColor,
    hoverBackground,
    activeColor,
    activeBackground,
    disabledColor,
    disabledBackground,
    name,
    ...restConfig
  } = config;
  return {
    [name]: omit(
      {
        color,
        background,
        '&:not(.disabled):not(:disabled)': {
          [theme.mediaQuery.desktopAndUp]: {
            '&:hover': {
              color: hoverColor,
              background: hoverBackground || background ? lighten(background) : undefined,
            },
          },
          '&:active': {
            color: activeColor,
            background: activeBackground || background ? darken(background) : undefined,
          },
        },
        '&.disabled': {
          color: disabledColor,
          background: disabledBackground,
        },
        '&:disabled': {
          color: disabledColor,
          background: disabledBackground,
        },
        ...restConfig,
      },
      'name',
    ),
  };
}
